/*!

 =========================================================
 * Vue Now UI Dashboard PRO Laravel - v1.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/vue-now-ui-dashboard-pro-laravel
 * Copyright Creative Tim (http://www.creative-tim.com) & UPDIVISION (https://www.updivision.com)

 * Coded by www.creative-tim.com & www.invisionapp.com & www.updivision.com
 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import DashboardPlugin from "./dashboard-plugin";

// Plugins
import App from "./App.vue";
import IsDemo from "./components/isDemo";
import routertable from "./components/RouterTable";
import VueMeta from "vue-meta";
// Mixins
import { formatMoney } from "./mixins/money";
import permissions from "./mixins/permissions";
import formatDate from "./mixins/date";
import cep from "./mixins/cep";
import format from "./mixins/format-mixin";
import validationsConfig from "./mixins/validations";
// Components
import loader from "./components/Loader";
import TablePagination from "./components/TablePagination";
import MySelect from "./components/MySelect";
import FilesAttach from "./components/FilesAttach";
import VueFileAgent from "vue-file-agent";
import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import "./assets/css/demo.css";

// router setup
import routes from "./routes";

import store from "./store";
import axiosConfig from "./axios/index";
import VueApexCharts from 'vue-apexcharts'

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(IsDemo);
Vue.use(VueMeta, { keyName: "head" });
Vue.use(VueFileAgent);
Vue.use(validationsConfig);
Vue.use(VueApexCharts)
Vue.component("router-table", routertable);
Vue.component("loader", loader);
Vue.component("n-pagination", TablePagination);
Vue.component("my-select", MySelect);
Vue.component("files-attach", FilesAttach);
Vue.component("multiselect", Multiselect);
Vue.component('apexchart', VueApexCharts)
Vue.filter("formatMoney", formatMoney);
Vue.mixin(permissions);
Vue.mixin(formatDate);
Vue.mixin(format);
Vue.mixin(cep);

/* eslint-disable no-new */
const app = new Vue({
  el: "#app",
  render: (h) => h(App),
  router: routes,
  store: store,
});

store.$app = app;
